export class UploadJsonHeadersModel {
    [x: string]: any;
    public id: any;
    public jsonsqlid: number;
    public name: string;
    public datakey: string;
    public position: string;
    public issortable: string;
    public edit: string;
    public istotalview: string;
    public colspancnt: string;
    public ishyperlinkview: string;
    public pagenav: string;
    public created_by: string;
    public created_dt: Date;
    public updated_by: string;
    public updated_dt: Date;
    public istotalcalculate: string;
    public comment: string;
    public colorder: number;
    public status: string;
    public isdisputeview: string;
    public isDisputeSubmitted: string;
    public btn_type: string;
    public pageName: string;
    public kpi_type: string;

    constructor() {
        this.kpi_type = null;
        this.pageName = null;
        this.id = null;
        this.jsonsqlid = null;
        this.name = null;
        this.datakey = null;
        this.position = null;
        this.issortable = null;
        this.edit = null;
        this.istotalview = null;
        this.colspancnt = null;
        this.ishyperlinkview = null;
        this.pagenav = null;
        this.created_by = null;
        this.created_dt = null;
        this.updated_by = null;
        this.updated_dt = null;
        this.istotalcalculate = null;
        this.comment = null;
        this.colorder = null;
        this.status = null;
        this.isdisputeview = null;
        this.isDisputeSubmitted = null;
        this.btn_type = null;
    }
}
